// Maps admission statuses to consistent, accessible colour tokens.
const S = {
  neutral: { text: '#64748B', bg: '#F1F5F9', border: '#CBD5E1' },
  indigo: { text: '#4F46E5', bg: '#E0E7FF', border: '#C7D2FE' },
  info: { text: '#2563EB', bg: '#DBEAFE', border: '#93C5FD' },
  purple: { text: '#7C3AED', bg: '#EDE9FE', border: '#C4B5FD' },
  teal: { text: '#0F766E', bg: '#CCFBF1', border: '#5EEAD4' },
  success: { text: '#16A34A', bg: '#DCFCE7', border: '#86EFAC' },
  darkgreen: { text: '#15803D', bg: '#DCFCE7', border: '#86EFAC' },
  error: { text: '#DC2626', bg: '#FEE2E2', border: '#FCA5A5' },
  orange: { text: '#EA580C', bg: '#FFEDD5', border: '#FDBA74' },
  warning: { text: '#D97706', bg: '#FEF3C7', border: '#FDE68A' },
};

const MAP = {
  'Enquiry': S.neutral,
  'Form Not Issued': S.neutral,
  'Form Issued': S.indigo,
  'Syllabus Sent': S.info,
  'Test Required': S.info,
  'Test Scheduled': S.purple,
  'Test Completed': S.teal,
  'Pass': S.success,
  'Fail': S.error,
  'Documents Pending': S.orange,
  'Documents Under Review': S.warning,
  'Documents Complete': S.teal,
  'Counselling Pending': S.orange,
  'Counselling Complete': S.teal,
  'Counsellor Recommended': S.info,
  'Office Recommended': S.info,
  'Awaiting Rector Approval': S.purple,
  'Returned': S.warning,
  'Approved': S.success,
  'Rejected': S.error,
  'Confirmation Sent': S.success,
  'Admission Completed': S.darkgreen,
  'On Hold': S.neutral,
};

export const statusStyle = (status) => MAP[status] || S.neutral;

export const docStyle = (status) => ({
  'Pending': S.orange,
  'Uploaded': S.info,
  'Under Review': S.warning,
  'Verified': S.success,
  'Correction Required': S.warning,
  'Rejected': S.error,
  'Not Required': S.neutral,
}[status] || S.neutral);
